var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":false,"color":"#007bff","loader":"bars","opacity":0.7,"z-index":999999}})}
var staticRenderFns = []

export { render, staticRenderFns }